import { useState } from "react";
import { Link, TableCell } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import LinkIcon from "@material-ui/icons/Link";
import LinkOffIcon from "@material-ui/icons/LinkOff";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { ActionButton } from "../../../UI/Table";
import DatePickerField from "../../../UI/Fields/DatePickerField";

import { lang } from "../../../../i18nLang";

interface ActionCellProps {
  open: boolean;
  className?: string;
  onClickCollapse: Function;
  onClickEdit: Function;
  onClickDelete: Function;
}

export const ActionCell = ({
  className,
  open,
  onClickCollapse,
  onClickEdit,
  onClickDelete,
}: ActionCellProps) => {
  return (
    <TableCell>
      <ActionButton
        title={lang("expand")}
        ariaLabel="expand row"
        className={className}
        onClick={onClickCollapse}
      >
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </ActionButton>
      <ActionButton
        title={lang("edit")}
        ariaLabel="edit"
        className={className}
        onClick={onClickEdit}
      >
        <EditIcon />
      </ActionButton>
      <ActionButton
        title={lang("delete")}
        ariaLabel="delete"
        className={className}
        onClick={onClickDelete}
      >
        <DeleteIcon />
      </ActionButton>
    </TableCell>
  );
};

interface MaturityDateLinkProps {
  id: string;
  date: string;
  onChange: (date: Date, value?: string) => void;
}

export const MaturityDateLink = ({
  id,
  date,
  onChange,
}: MaturityDateLinkProps) => {
  const [open, setOpen] = useState(false);
  const name = `maturity-date-${id}`;

  const hadleOpenPicker = () => setOpen(true);
  const hadleClosePicker = () => setOpen(false);

  const handleClickDate = (ev) => {
    ev.preventDefault();
    hadleOpenPicker();
  };

  return (
    <>
      <Link
        href="#"
        onClick={handleClickDate}
        color="inherit"
        underline="always"
      >
        {date}
      </Link>
      <DatePickerField
        name={name}
        onChange={onChange}
        open={open}
        onOpen={hadleOpenPicker}
        onClose={hadleClosePicker}
        style={{ display: "none" }}
      />
    </>
  );
};

export const MeasurementLink = ({ id, name }: { id: string; name: string }) => {
  return id ? (
    <div style={{ display: "flex" }}>
      <LinkIcon /> {lang("measurements.measuremntLink", name)}
    </div>
  ) : (
    <div style={{ display: "flex" }}>
      <LinkOffIcon /> {lang("measurements.noLink")}
    </div>
  );
};
